import { isRefundEntry } from "./refund";

/**
 * Decisões de conteúdo do comprovante em PDF de um lançamento do extrato.
 *
 * Mora fora do componente porque a montagem do PDF é uma sequência longa de
 * chamadas do jsPDF: separar o "o que escrever" do "onde escrever" é o que
 * torna estas regras verificáveis.
 */
export function buildReceiptFields(item) {
  const isRefund = isRefundEntry(item);
  const isDebit = `${item?.type || ""}`.toUpperCase().includes("DEBIT");
  // Na devolução o dinheiro sai da conta, então ela se comprova como um
  // pagamento: quem aparece do outro lado é o beneficiário, não o pagador.
  const isOutbound = isDebit || isRefund;

  const cents = Number(item?.amount_cents);
  const rawAmount = Number.isNaN(cents)
    ? Number(item?.amount || 0)
    : cents / 100;

  const endToEndId = isRefund
    ? item?.refund_end_to_end_id || item?.end_to_end_id || "--"
    : item?.end_to_end_id || "--";

  return {
    isRefund,
    isOutbound,

    title: isRefund
      ? "Comprovante de Devolução"
      : isDebit
        ? "Comprovante de Pagamento"
        : "Comprovante de Recebimento",

    // A devolução chega com o valor negativo, porque no extrato ela é uma
    // saída. No comprovante quem informa o sentido são o título e as seções
    // de emissor/beneficiário, então o valor sai pela magnitude.
    amount: Math.abs(Number.isNaN(rawAmount) ? 0 : rawAmount),

    idLabel: isRefund ? "ID da devolução" : "ID da transação",
    transactionId:
      (isRefund && item?.refund_id) || item?.reference || item?.id || "--",

    endToEndId,
    // Só faz sentido citar o Pix original quando o EndToEnd acima é o da
    // devolução; senão o comprovante repetiria a mesma linha duas vezes.
    originalEndToEndId:
      isRefund && item?.refund_end_to_end_id ? item?.end_to_end_id || "" : "",

    counterpartyLabel: isOutbound ? "Beneficiário" : "Pagador",
    holderLabel: isOutbound ? "Emissor" : "Recebedor",
  };
}
